import psychologyConsultationQuestionSet from "../faq/psychologyConsultation/allQuestions";

export const psychologyConsultation = {
    'meta': {
        'title': 'Psycholog #city#, porady psychologiczne • Centrum COLLIGO',
        'description': 'psycholog #city#, porady psychologiczne. Porady udzielane przez wykwalifikowanych i doświadczonych psychologów. Krótkie terminy oczekiwania na wizytę, bezpieczna przestrzeń.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'price': {
        'torun': {
            'first': 'od 190',
            'next': 'od 190'
        },
        'bydgoszcz': {
            'first': 'od 200',
            'next': 180
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/psycholog/',
        'title': 'Porady psychologiczne #cityLocativeIn#',
        'name': 'Porady psychologiczne #cityLocativeIn#',
        'heading': 'psycholog #city#, porady psychologiczne',
        'fullName': 'Porady psychologiczne'
    },
    'image': {
        'url': '/images/services/porady-psychologiczne.webp',
        'width': 886,
        'height': 295,
        'alt': 'Porady psychologiczne'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/porady-psychologiczne.webp',
            'width': 886,
            'height': 295,
            'alt': 'Porady psychologiczne'
        }
    },
    'faq': psychologyConsultationQuestionSet
}